import { Box } from '../Box';
import { CircularProgress } from '../CircularProgress';

export const Loader = () => (
  <Box
    display="flex"
    justifyContent="center"
    p="32"
    className="aqa_file_preview_loader"
  >
    <CircularProgress size={50} />
  </Box>
);
